<template>
  <div class="rc-data-table" :class="{ padding24: padding24 }">
    <div class="rc-table-search">
      <slot name="butLeft">
        <rc-form
          ref="form"
          v-bind="$attrs.form"
          :table-refs="$refs"
          v-on="$listeners"
          @click="search"
        >
          <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
            <slot :name="name" v-bind="scope" :index="_index"></slot>
          </template>
        </rc-form>
      </slot>
      <div class="rc-table-search-btn">
        <slot name="butRight"></slot>
        <rc-but-list
          ref="but"
          :class="`rc-but-list-${align}`"
          :align="align"
          v-bind="$attrs.but"
          v-on="$listeners"
          @confirm="(item, index, obj) => confirmHandle(item, index, { ...obj, dialogProp: true })"
        >
          <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
            <slot :name="name" v-bind="scope" :index="_index"></slot>
          </template>
        </rc-but-list>
      </div>
    </div>
    <rc-table
      ref="table"
      :params="comParams"
      :visible.sync="visibleDef"
      v-bind="$attrs"
      v-on="$listeners"
      @prop-source="tableDelete"
      @confirm="confirmHandle"
      @selection-change="selectionChange"
    >
      <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
        <slot :name="name" v-bind="scope" :index="_index"></slot>
      </template>
    </rc-table>
    <rc-dialog
      ref="dialog"
      :visible.sync="visibleDef"
      v-bind="dialogData"
      :prop-source="propSource"
      v-on="$listeners"
      @confirm="confirmHandle"
    >
      <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
        <slot :name="name" v-bind="scope" :index="_index"></slot>
      </template>
    </rc-dialog>
  </div>
</template>

<script>
import { emitFun } from "@/utils";
import { rcSearch } from "../RcBase/mixins/slotMixins";
export default {
  name: "RcDataTable",
  mixins: [rcSearch],
  props: {
    align: {
      type: String,
      default: "right",
      validator: () => ["left", "center", "right"]
    },
    padding24: {
      type: Boolean,
      default: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleDef: false,
      paramsDef: {},
      dialogData: {},
      propSource: null
    };
  },
  computed: {
    refs() {
      const obj = {
        ...this.$refs.table.refs,
        dialog: this.$refs.dialog,
        rcDataTable: this.$refs.table,
        but: this.$refs.but,
        form: this.$refs.form
      };
      this.$emit("refs", obj);
      return obj || {};
    },
    rcDataTable() {
      return this.refs.rcDataTable;
    },
    table() {
      return this.refs.table;
    },
    comParams() {
      return { ...this.params, ...this.paramsDef };
    }
  },
  watch: {
    visible: {
      handler(bool) {
        this.visibleDef = bool;
      },
      immediate: true
    }
  },
  methods: {
    setPropSource(item) {
      this.propSource = item;
    },
    attrsDialog(item) {
      const { dialog } = this.$attrs;
      return dialog.multiple ? dialog[item.prop] : dialog || {};
    },
    confirmHandle(item, index, obj) {
      this.propSource = item;
      this.setPropSource(item);
      if (obj.dialogProp || item.dialogProp) {
        this.dialogData = this.attrsDialog(item);
        this.setVisible();
      } else {
        this.dialogData = {};
      }
      emitFun(
        { self: this, emit: false },
        { item, index },
        { ...obj, refs: this, name: "rcDataTable" }
      );
    },
    tableDelete(item) {
      this.setPropSource(item);
    },
    selectionChange(selection) {
      this.selection = selection;
    },
    search(val, { prop, component }) {
      if (component === this.rcSearch) {
        this.$set(this.paramsDef, prop, val);
        this.refresh();
      }
    },
    refresh() {
      this.$nextTick(() => {
        this.rcDataTable.getTable();
      });
    },
    dialogCancel() {
      this.table.clearSelection();
    },
    dialogConfirm() {
      return this.selection;
    },
    setVisible(state = true) {
      this.visibleDef = state;
    },
    go({ name }) {
      this.$router.push({ name });
    }
  }
};
</script>

<style lang="scss" scoped>
.padding24 {
  padding: 24px;
}
.rc-table-search {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .rc-table-search-btn {
    display: flex;
  }
}
</style>
